import { render, staticRenderFns } from "./Armazenamentos.vue?vue&type=template&id=6c8c82d0&"
import script from "./Armazenamentos.vue?vue&type=script&lang=js&"
export * from "./Armazenamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports